export default "__VITE_ASSET__CCgbEwEN__"